import isUserRolGuard from "@/guards/isUserRolGuard";
import UsuarioBloqueado from "@/pages/BlockedUsers.vue";

export default [
  {
    path: "bloqueado",
    name: "bloqueado",
    component: UsuarioBloqueado,
    beforeEnter: isUserRolGuard,
    meta: { showBackButton: true },
  }
];
